import PropTypes from 'prop-types';
import clsx from 'clsx';
import LoaderSkeleton from '@components/LoaderSkeleton';
import DocTableRow from '@features/DocViewer/Steps/Docs/DocTableRow/DocTableRow';
import CustomCheckbox from '@components/shared/CustomCheckbox';
import Arrow from '@assets/icons/arrow.svg';
import { SIGNATURES_PAGE_LIMIT } from '@shared/constants';
import signatureId from '@shared/helpers/signatureId';
import styles from './DocsTable.module.scss';
import { isSelected } from '../DocTableRow/helpers';
import { SORT_VALUES } from '../constants';

const DocsTable = ({
  data,
  onChangeSort,
  sort,
  handleRowSelect,
  handleSelectAllClick,
  areAllSelected,
  selected,
}) => {
  return (
    <table className={styles.table}>
      <thead>
        <tr className={'body2'}>
          <th className={styles.firstCol}>
            <CustomCheckbox
              checked={areAllSelected}
              onChange={handleSelectAllClick}
              small
              label='Docs'
            />
          </th>
          <th className={styles.secondCol} onClick={onChangeSort}>
            <span>
              Date
              <Arrow
                height={12}
                width={12}
                className={clsx(
                  'rotate90',
                  sort === SORT_VALUES.asc && 'rotate270',
                )}
              />
            </span>
          </th>
          <th>Type of consent</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {data
          ? data?.signatures?.map(item => (
              <DocTableRow
                key={signatureId(item)}
                item={item}
                currentPage={data?.currentPage}
                isSelected={isSelected(selected, signatureId(item))}
                onSelect={handleRowSelect}
              />
            ))
          : Array.from({ length: SIGNATURES_PAGE_LIMIT }, (_, index) => (
              <tr key={index} className={styles.skeleton}>
                <td>
                  <LoaderSkeleton
                    width={'100%'}
                    customStyle={styles.skeletonLoader}
                  />
                </td>
                <td>
                  <LoaderSkeleton
                    width={'80%'}
                    customStyle={styles.skeletonLoader}
                  />
                </td>
                <td>
                  <LoaderSkeleton
                    width={'80%'}
                    customStyle={styles.skeletonLoader}
                  />
                </td>
                <td>
                  <LoaderSkeleton
                    width={'100%'}
                    customStyle={styles.skeletonLoader}
                  />
                </td>
              </tr>
            ))}
      </tbody>
    </table>
  );
};

DocsTable.propTypes = {
  data: PropTypes.shape({
    signatures: PropTypes.arrayOf(
      PropTypes.shape({
        user_id: PropTypes.string,
        date: PropTypes.string,
        form_name: PropTypes.string,
        signature_type: PropTypes.string,
        signed_doc_url: PropTypes.string,
      }),
    ),
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
  }),
  onChangeSort: PropTypes.func,
  sort: PropTypes.string,
  selected: PropTypes.object,
  areAllSelected: PropTypes.bool,
  count: PropTypes.number,
  handleRowSelect: PropTypes.func,
  handleSelectAllClick: PropTypes.func,
};

export default DocsTable;
